<template>
  <div class="sharCard">
    <div class="noComment">
      <div class="sharCard_top">
        <div class="user" @click="jumpDiary(myitem.user_id)">
          <div class="head">
            <img :src="myitem.avatar" alt="" />
          </div>
        </div>
        <!-- 用户分享内容部分 -->
        <div class="share_content">
          <!-- 用户ID -->
          <div class="user_id" @click="jumpDiary(myitem.user_id)">
            {{ myitem.username }}
          </div>

          <!-- 用户累计打卡天数 -->
          <div class="user_day_box">
            <span class="user_day">累计打卡{{ myitem.sign_days }}天</span>
          </div>
          <!-- 用户来自哪个训练营和章节 -->
          <div class="UserFrom" @click="mylink(myitem.camp_id)">
            {{ myitem.camp_name }}
            {{ myitem.what_section }}
          </div>
          <!-- 用户分享的文字内容部分 -->
          <div class="user_content">
            <p class="contentTitle">{{ myitem.content | contentTitle }}</p>
            <p>{{ myitem.content | contentText }}</p>
          </div>
          <!-- 用户分享图片内容部分 -->
          <div class="userShare_Image" v-if="myitem.img[0].length > 5">
            <img
              :preview="myitem.share_id"
              :src="item"
              alt=""
              v-for="(item, index) in myitem.img"
              :key="index"
              class="tu"
            />
            <ul class="tuBox">
              <li
                class="tu tukuang"
                v-for="(item, index) in myitem.img"
                :key="index"
                :style="{ 'background-image': 'url(' + item + ')' }"
              ></li>
            </ul>
          </div>
          <!-- 用户分享的时间 -->
          <div class="card_time">
            <!-- 左侧时间部分 -->
            <div class="leftTime">
              {{role == "child"?"楼主   ":""}}{{ myitem.created_at }}
            </div>
            <!-- 右侧点赞评论部分 -->
            <div class="sharEdit">
              <div class="sharEditItem">
                <giveLike :mygiveLike="myitem" :share_id="myitem.share_id">
                </giveLike>
              </div>
              <div class="sharEditItem" @click="changeComment">
                <div>评论 {{ myitem.remark_count }}</div>
              </div>
              <div class="sharEditItem">
                <div @click="myopen()">查看详情</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="comment_tr">
      <div v-show="commentFlag" class="comment_anm">
        <comment
          :role="role"
          :mycomment="commentlist"
          :share_id="myitem.share_id"
          @changePage="page($event)"
        ></comment>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import comment from "./comment.vue";
import giveLike from "./giveLike.vue";
export default {
  name: "sharCard",
  components: { giveLike, comment },
  props: {
    role: {
      type: String,
      default: "parent",
    },
    myitem: {
      type: Object,
      default: () => {
        return {
          avatar: "http://upload.5kjs.hk/upload/user/626061173.png",
          camp_name: "测试特训营",
          content: "分享内容2",
          created_at: "2021-08-06 11:17:28",
          img: [
            "http://upload.5kjs.hk/upload/camp_share/20210806\\a74b2bc1042bfe5dd603fce88fe4d3fd.png",
            "http://upload.5kjs.hk/upload/camp_share/20210806\\960f969d4432b46e3830085040127dff.jpg",
          ],
          praised_count: 0,
          remark_count: 0,
          share_id: 2,
          user_id: 57034,
          username: "测试",
        };
      },
    },
  },
  data() {
    return {
      // 是否显示评论盒子
      commentFlag: false,
      // 当前分享下的评论列表
      commentlist: {},
      // 评论页码
      pageNum: 1,
      // 每次显示评论限制数量
      limit: 8,
    };
  },
  computed: {
    ...mapState(["token", "agency_id"]),
  },
  methods: {
    ...mapMutations(["newOpen", "scrollToTop"]),
    // 评论盒子的显隐
    changeComment() {
      if (this.myitem.is_status == 1) {
        this.commentFlag = !this.commentFlag;
        if (this.commentFlag == true) {
          // 请求当前分享下的评论
          this.getRemark();
        }
      } else {
        this.$message("日记还在审核，不能评论噢~");
      }
    },
    // 根据图片数量自动适配图片展示方式
    AutoImg() {
      var imgs = document.querySelectorAll(".userShare_Image");
      for (var i = 0; i < imgs.length; i++) {
        var child = imgs[i].children;
        if (child.length < 5) {
          imgs[i].style.cssText = "width:18rem";
        }
      }
    },
    // 请求当前分享下的评论数据
    getRemark() {
      this.$axios
        .get("/getRemark", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            share_id: this.myitem.share_id,
            page: this.pageNum,
            limit: this.limit,
          },
        })
        .then((doc) => {
          this.commentlist = doc;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下方话题跳转
    mylink(id) {
      // 跳转超话的内容保留
      // this.$router.push({ path: `/Detail/Introduce/${id}` });
      this.$router.push({ path: `/Detail/apply/${id}` });
      this.scrollToTop(0);
    },
    // 分页
    page(event) {
      this.pageNum = event;
      if (this.commentFlag == true) {
        // 请求当前分享下的评论
        this.getRemark();
      }
    },
    // 过滤打开新窗口、
    myopen() {
      if (this.role == "parent") {
        this.newOpen(this.myitem.share_id);
      }
    },
    // 跳转打卡日记
    jumpDiary(id) {
      // 如果是已经在打卡日记页面则阻断跳转
      if (this.$route.query.user_id_to != null) {
        return;
      }
      this.$router.push({
        path: `/home/${this.myitem.camp_id}`,
        query: {
          camp: this.myitem.camp_id,
          user_id_to: id,
        },
      });
    },
  },
  mounted() {
    this.AutoImg();
    // 判断当前组件是否为一级组件（一级组件不会显示分页）
    if (this.role == "child") {
      this.commentFlag = true;
      if (this.commentFlag == true) {
        // 请求当前分享下的评论
        this.getRemark();
      }
    }
    setTimeout(() => {
      this.$previewRefresh();
    }, 0);
  },
  watch: {
    // 如果图片数据有更新则重新计算图片排序
    myitem(newVla) {
      this.AutoImg();
      return newVla;
    },
  },
  filters: {
    // 截取有#符号的头部
    contentTitle(item) {
      // 首先判断当前评论中是否有#符号
      let title = "";
      let status = item.indexOf("#");
      if (status != -1) {
        let flag = item.match(/^#.+#/);
        if (flag != null) {
          title = flag[0]
        }
      }
      return title;
    },
    contentText(item) {
      // 首先判断当前评论中是否有#符号
       let title = "";
        let flag = item.split(/#.+#/);
        if (flag.length != 1) {
          title = flag[1]
        }else{
           title = flag[0]
        }
      return title;
    },
  },
};
</script>

<style lang="less" scoped>

.contentTitle{
  size: 0.675rem !important;
  color: rgb(117, 117, 117);
}

// 用户打卡分享组件
.sharCard {
  // margin-top: 0.75rem;
  box-sizing: border-box;
  width: 43.125rem;
  background: #ffffff;
  // border: 1px solid #eeeeee;
  transition: all 0.5s ease;
  -moz-transition: all 2s ease; /* Firefox 4 */
  -webkit-transition: all 2s ease; /* Safari and Chrome */
  -o-transition: all 2s ease; /* Opera */
  // 上半部分用户头像以及内容部分
  .noComment {
    padding: 1.9375rem 1.0625rem;
    padding-bottom: 0;
  }
  .sharCard_top {
    display: flex;
    flex-direction: row;
    width: 100%;
    // 用户头像部分
    .user {
      cursor: pointer;
      margin-right: 0.6875rem;
      .head {
        padding: 0;
        margin: 0;
        width: 3.125rem;
        height: 3.125rem;
        border-radius: 50%;
        overflow: hidden;
        // border: 1px solid red;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    // 用户ID以及分享内容部分
    .share_content {
      width: 100%;
      height: auto;
      border-bottom: 0.0625rem solid #f0f1f1;
      .user_id {
        cursor: pointer;
        width: 100%;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #333333;
      }
      // 用户来自哪个训练营和章节
      .UserFrom {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ff6b5f;
        line-height: 1.625rem;
        cursor: pointer;
      }
    }
    // 用户分享的文字内容部分
    .user_content {
      margin-top: 0.3125rem;
      margin-bottom: 1.6875rem;
      width: 100%;
      height: auto;
      font-size: 0.875rem;
      font-family: " Microsoft YaHei";
      font-weight: 400;
      color: #666666;
      line-height: 1.625rem;
    }
    // 用户分享的图片内容部分
    .userShare_Image {
      position: relative;
      margin: 1.9375rem 0 0.6875rem 0;
      width: 22.25rem;
      height: auto;
      overflow: hidden;
      img {
        opacity: 0;
      }
      .tu {
        // 鼠标悬浮样式变化
        position: relative;
        z-index: 2;
        display: inline-block;
        cursor: pointer;
        width: 6.875rem;
        height: 6.875rem;
        margin-right: 0.25rem;
      }
      .tukuang {
        z-index: 1;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }
      .tuBox {
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        // background-color: red;
      }
      // img:nth-child(3n) {
      //   margin-right: 0;
      // }
    }
    // 用户分享的时间地点
    .card_time {
      margin-bottom: 2rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      // 左侧时间部分
      .leftTime {
        font-size: 0.75rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #838383;
      }
      // 右侧分享操作部分
      .sharEdit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .sharEditItem {
          margin: 0 1.0625rem;
          cursor: pointer;
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #999999;
          /deep/ .giveLike {
            .img-box {
              height: auto;
            }
            .icon-zan:before {
              color: #999999 !important;
            }
            .noActive {
              color: #999999;
            }
          }
        }
      }
    }
    // 用户累计打卡天数
    .user_day_box {
      margin: 0.5rem 0 1.4125rem 0;
      box-sizing: content-box;
      display: inline-block;
      padding: 0 0.6875rem;
      padding-bottom: 0.125rem;
      width: auto;
      height: 1.25rem;
      background: rgba(38, 211, 188, 0.1);
      border-radius: 0.625rem;
      .user_day {
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #26d3bc;
        // line-height: 1.625rem;
      }
    }
  }
  // 下半部分用户点赞以及评论展开部分
  .sharCard_bottom {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 2.375rem;
    border: 0.0625rem solid #eeeeee;
    .sharCard_bottom_item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 33.3%;
      height: 100%;
      border-right: 0.0625rem solid #eeeeee;
      div {
        font-size: 0.75rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #424242;
        cursor: pointer;
      }
    }
    .sharCard_bottom_item:hover {
      div {
        color: #ff5f53;
      }
      /deep/ .font {
        color: #ff5f53 !important;
      }
    }
    .sharCard_bottom_item:last-child {
      border-right: none;
    }
  }
}

/*v-enter 是进入之前，元素的起始状态*/
/*v-leave-to 离开之后动画的终止状态*/
.comment_tr-enter,
.comment_tr-leave-to {
  opacity: 0; /*透明度*/
  transform: translateY(0);
  transform: scaleY(0);
  height: 0px;
}

.comment_tr-leave,
.comment_tr-enter-to {
  opacity: 1; /*透明度*/
  transform: scaleY(1);
  height: 0px;
}

/*入场(离场)动画的时间段   */
.comment_tr-enter-active,
.comment_tr-leave-active {
  transition: all 0.3s ease;
}

.comment_box-enter-active,
.comment_box-leave-active {
  transition: all 0.3s;
}

.comment_box-enter,
.comment_box-leave-to {
  transition: all 0.3s;
}
</style>